import { DashboardModuleListItem, StatusBadge } from '@domain-group/suit-theme'

import { capitalizeString } from '@domain-group/javascript-utils'

import useStatus from '@hooks/useStatus'

import { confirmDelete } from '@functions/entity'

import type { ProviderDeepLinkModel, ProviderModel } from '@models/types'
import useProviderDeepLink from '@hooks/useProviderDeepLink'

interface DeepLinkProps {
  provider: ProviderModel,
  providerDeepLink: ProviderDeepLinkModel,
}

const DeepLink = (props: DeepLinkProps) => {
  const {
    provider,
    providerDeepLink,
  } = props

  const { status_id, title, url } = providerDeepLink

  const providerDeepLinkPayload = useProviderDeepLink(providerDeepLink, provider)
  const {
    callbacks: {
      createOrEditProviderDeepLink,
      updateProviderDeepLinks,
    },
  } = providerDeepLinkPayload

  const { color, status } = useStatus({ id: status_id })

  const confirmDeletePayload = {
    callbacks: {
      deleteFn: () => updateProviderDeepLinks({ providerDeepLink, mode: 'delete' }),
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Deep Link',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={url}
      title={capitalizeString(title ?? '')}
    >
      <StatusBadge
        boxProps={{ marginLeft: 'medium' }}
        // @ts-expect-error TS2339
        color={status?.title ? color : 'mysteryGrey'}
        ghost
        // @ts-expect-error TS2339
        text={status?.title || 'All'}
      />

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditProviderDeepLink()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />

        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default DeepLink
